import React from 'react';

export const ContentRightImage = () => {
  return (
    <div className="il-add" style={{ backgroundImage: `url("/img/content/contents-right.jpeg")`}}></div>
  );
};